var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKhachhang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/profile-2user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 2.08691C6.38 2.08691 4.25 4.21691 4.25 6.83691C4.25 9.40691 6.26 11.4869 8.88 11.5769C8.96 11.5669 9.04 11.5669 9.1 11.5769C9.12 11.5769 9.13 11.5769 9.15 11.5769C9.16 11.5769 9.16 11.5769 9.17 11.5769C11.73 11.4869 13.74 9.40691 13.75 6.83691C13.75 4.21691 11.62 2.08691 9 2.08691Z",
    fill: "#3783DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0809 14.2368C11.2909 12.3768 6.74094 12.3768 3.93094 14.2368C2.66094 15.0868 1.96094 16.2368 1.96094 17.4668C1.96094 18.6968 2.66094 19.8368 3.92094 20.6768C5.32094 21.6168 7.16094 22.0868 9.00094 22.0868C10.8409 22.0868 12.6809 21.6168 14.0809 20.6768C15.3409 19.8268 16.0409 18.6868 16.0409 17.4468C16.0309 16.2168 15.3409 15.0768 14.0809 14.2368Z",
    fill: "#3783DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.9894 7.42701C20.1494 9.36701 18.7694 11.067 16.8594 11.297C16.8494 11.297 16.8494 11.297 16.8394 11.297H16.8094C16.7494 11.297 16.6894 11.297 16.6394 11.317C15.6694 11.367 14.7794 11.057 14.1094 10.487C15.1394 9.56701 15.7294 8.18701 15.6094 6.68701C15.5394 5.87701 15.2594 5.13701 14.8394 4.50701C15.2194 4.31701 15.6594 4.19701 16.1094 4.15701C18.0694 3.98701 19.8194 5.44701 19.9894 7.42701Z",
    fill: "#3783DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.9922 16.6768C21.9122 17.6468 21.2922 18.4868 20.2522 19.0568C19.2522 19.6068 17.9922 19.8668 16.7422 19.8368C17.4622 19.1868 17.8822 18.3768 17.9622 17.5168C18.0622 16.2768 17.4722 15.0868 16.2922 14.1368C15.6222 13.6068 14.8422 13.1868 13.9922 12.8768C16.2022 12.2368 18.9822 12.6668 20.6922 14.0468C21.6122 14.7868 22.0822 15.7168 21.9922 16.6768Z",
    fill: "#3783DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhachhang);
export default __webpack_public_path__ + "static/media/khachhang.e049457e0ae4578604c5a3a2dccb340d.svg";
export { ForwardRef as ReactComponent };